// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/user.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "../../../../google/protobuf/timestamp_pb";
import { file_google_protobuf_timestamp } from "../../../../google/protobuf/timestamp_pb";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/user.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_user: GenFile = /*@__PURE__*/
  fileDesc("CjJxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvdXNlci5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIqECCgRVc2VyEh4KAmlkGAEgASgJQg2CtRgJEgd1c2VyX2lkSACIAQESFgoJdGVuYW50X2lkGAIgASgJSAGIAQESHgoRYWNrbm93bGVkZ2VkX2V1bGEYAyABKAhIAogBARI/ChZkYXRlX2Fja25vd2xlZGdlZF9ldWxhGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgDiAEBEiEKFGFja25vd2xlZGdlZF9jb29raWVzGAUgASgISASIAQFCBQoDX2lkQgwKCl90ZW5hbnRfaWRCFAoSX2Fja25vd2xlZGdlZF9ldWxhQhkKF19kYXRlX2Fja25vd2xlZGdlZF9ldWxhQhcKFV9hY2tub3dsZWRnZWRfY29va2llc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_quanterix_common_extensions_v1_field_options]);

/**
 * Represents the identity of a user
 *
 * This message is introduced to avoid including string user fields in higher
 * level messages, which would be likely to require future breaking changes.
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.User
 */
export type User = Message<"quanterix.simoa_one.analysis_app_api.v1.User"> & {
  /**
   * Unique identifier
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Tenant identifier
   *
   * @generated from field: optional string tenant_id = 2;
   */
  tenantId?: string;

  /**
   * True if the user has acknowledged the EULA
   *
   * @generated from field: optional bool acknowledged_eula = 3;
   */
  acknowledgedEula?: boolean;

  /**
   * Represents the point in time at which the user acknowledged the EULA,
   * independent of timezone
   *
   * @generated from field: optional google.protobuf.Timestamp date_acknowledged_eula = 4;
   */
  dateAcknowledgedEula?: Timestamp;

  /**
   * True if the user has acknowledged acceptance of cookies
   *
   * @generated from field: optional bool acknowledged_cookies = 5;
   */
  acknowledgedCookies?: boolean;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_user, 0);

